import { render, staticRenderFns } from "./BagelLogo.vue?vue&type=template&id=4486c948&"
import script from "./BagelLogo.vue?vue&type=script&lang=js&"
export * from "./BagelLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports